/*

Mostly cribbed from the Bootstrap modals but with the backdrop stuff stripped out

Recommended m2g-modal template:

<div class="m2g-modal m2g-modal--modal-closed">
    <div class="m2g-modal-header">
        <button class="m2g-modal-close-button" data-dismiss="m2g-modal">×</button>
        <span class="m2g-modal-title">Title</span>
    </div>
    <div class="m2g-modal-body">
        <div class="m2g-modal-alert">
        </div>
    </div>
    <div class="m2g-modal-footer">
        <div class="m2g-modal-footer-left"></div>
        <div class="m2g-modal-footer-right"></div>
    </div>
</div>

*/
import jQuery from 'jquery';
import _ from 'lodash';

const UI = Mobi2Go.UI || {};
const { helpers } = UI;
const $window = jQuery(window);
const $body = jQuery('body');
const $view_container = jQuery('#m2g-view[data-m2g-view]');
let instance = 0;
let currently_open_modal = null;
const $overlay = jQuery('#m2g-view[data-m2g-view] .m2g-modal-overlay');
const should_animate = false;
const { getPageYOffset } = helpers;

UI.Modal = function(element) {
    this.$element = jQuery(element);
    this.allow_close = true;
    this.is_open = false;
    this.is_forced_open = false;
    this.onBeforeClose = null;

    this.$element
        .addClass('m2g-modal m2g-modal--modal-closed')
        .find('[data-dismiss="modal"]')
        .click(_.bind(this.close, this));

    // Add bind and trigger methods
    Mobi2Go.app.mixinEvents(`UIModal#${instance++}`, this);
};

UI.Modal.isOpen = function() {
    return currently_open_modal;
};

UI.Modal.forceClose = function() {
    if (!currently_open_modal) {
        return;
    }
    currently_open_modal.close(false, true);
};

UI.Modal.prototype.isOpen = function() {
    return this.is_open;
};

UI.Modal.prototype.freeze = function() {
    this.$element.addClass('m2g-modal--modal-frozen');
    $view_container.addClass('m2g-view--modal-frozen');
    $body.addClass('m2g-open-modal--frozen');
    this.allow_close = false;

    return this;
};

UI.Modal.prototype.unfreeze = function() {
    this.$element.removeClass('m2g-modal--modal-frozen');
    $view_container.removeClass('m2g-view--modal-frozen');
    $body.removeClass('m2g-open-modal--frozen');

    this.allow_close = true;

    return this;
};

UI.Modal.prototype.isFrozen = function() {
    return !this.allow_close;
};

UI.Modal.prototype.open = function() {
    this.$element
        .removeClass('m2g-modal--modal-closed')
        .addClass('m2g-modal--modal-open');
    this.updatePosition({ no_animation: true });

    $view_container
        .removeClass('m2g-view--modal-closed')
        .addClass('m2g-view--modal-open');

    $overlay
        .removeClass('m2g-modal-overlay--modal-closed')
        .addClass('m2g-modal-overlay--modal-open');

    $body.addClass('m2g-open-modal');

    currently_open_modal = this;
    this.is_open = true;

    UI.trigger('modalOpen', this);

    return this;
};

UI.Modal.prototype.close = function(retain_overlay, force_close) {
    if (
        force_close !== true &&
        (!this.allow_close || (this.onBeforeClose && !this.onBeforeClose()))
    ) {
        return;
    }

    this.$element
        .removeClass('m2g-modal--modal-open')
        .addClass('m2g-modal--modal-closed');

    retain_overlay = retain_overlay === true;

    if (!retain_overlay) {
        $view_container
            .removeClass('m2g-view--modal-open m2g-view--modal-frozen')
            .addClass('m2g-view--modal-closed');

        $overlay
            .removeClass('m2g-modal-overlay--modal-open')
            .addClass('m2g-modal-overlay--modal-closed');

        $body.removeClass('m2g-open-modal');
    }

    currently_open_modal = null;
    this.is_open = false;
    UI.trigger('modalClose', this);

    return this;
};

UI.Modal.prototype.setOnBeforeClose = function(callback) {
    if (_.isFunction(callback)) {
        this.onBeforeClose = callback;
    }
};

/**-------------------------------------------------------------------------
 * Page centering
 */
let prev_page_offset = 0;
let modal_offset = 0;
const margin = 18;

UI.Modal.prototype.updatePosition = function(options) {
    const window_height = $window.height();
    const view_height = $view_container.height();
    const view_offset = $view_container.offset().top;
    const modal_height = this.$element.height();
    const page_offset = getPageYOffset();
    let new_modal_offset = page_offset - view_offset;
    const max_offset = view_height - modal_height;
    const is_scrolling_down = page_offset >= prev_page_offset;

    prev_page_offset = page_offset;

    if (window_height > modal_height) {
        // center
        new_modal_offset += (window_height - modal_height) / 2;
    } else {
        // Scroll positioning

        const modal_offset_top = modal_offset - margin;
        const modal_offset_bottom =
            modal_offset_top + modal_height + margin * 2;
        const viewport_top = page_offset - view_offset;
        const viewport_bottom = page_offset + window_height - view_offset;

        if (
            viewport_top >= modal_offset_top &&
            viewport_bottom <= modal_offset_bottom
        ) {
            return;
        }

        // Lower range
        if (new_modal_offset && is_scrolling_down) {
            new_modal_offset -= modal_height + margin * 2 - window_height;
        }

        new_modal_offset += margin;
    }

    if (new_modal_offset > max_offset) {
        new_modal_offset = max_offset;
    }

    if (new_modal_offset < 0) {
        new_modal_offset = 0;
    }

    if (options && options.no_animation) {
        this.setOffsetWithoutAnimation(new_modal_offset);
    } else if (options && options.force_animation) {
        this.setOffsetWithAnimation(new_modal_offset);
    } else {
        this.setOffset(new_modal_offset);
    }
};

UI.Modal.prototype.setOffset = function(y) {
    // this.$element.attr('style', 'top:' + y + 'px;');
    // iOS does not emit scroll events during scroll 'inertia', so
    // use an animtion.
    // Using margin rather than translate because subpixel anti-aliasing
    // isn’t supported when an element is being hardware accelerated
    // in chrome.
    if (should_animate) {
        this.setOffsetWithAnimation(y);
    } else {
        this.setOffsetWithoutAnimation(y);
    }
};

UI.Modal.prototype.setOffsetWithoutAnimation = function(offset) {
    if (should_animate) {
        this.$element.attr(
            'style',
            `-webkit-transform: translate3d(0,${offset}px, 0);`
        );
    } else {
        this.$element.attr('style', `top: ${offset}px;`);
    }
    modal_offset = offset;
};

UI.Modal.prototype.setOffsetWithAnimation = function(offset) {
    let style;
    if (should_animate) {
        style = `${'transition: -webkit-transform .33s ease-in-out;' +
            '-webkit-transform: translate3d(0,'}${offset}px,0)`;
    } else {
        style = `${'transition: top .33s ease-in-out;' + 'top: '}${offset}px;`;
    }

    this.$element.attr('style', style);
    modal_offset = offset;
};

UI.Modal.prototype.showBottom = function() {
    const window_height = $window.height();
    const view_offset = $view_container.offset().top;
    const modal_height = this.$element.height();
    const page_offset = getPageYOffset();
    let new_modal_offset = page_offset - view_offset;

    if (window_height > modal_height) {
        return;
    }

    new_modal_offset -= modal_height + margin * 2 - window_height;

    this.setOffsetWithAnimation(new_modal_offset);
};

// Global modal closer
$overlay.click(function() {
    currently_open_modal && currently_open_modal.close();
});

// Close on escape press
jQuery('body').keyup(function(e) {
    currently_open_modal && e.which === 27 && currently_open_modal.close();
});

// Modal viewport centering
$window.scroll(centerCurrentlyOpenModal);
$window.resize(_.debounce(centerCurrentlyOpenModal, 50));

function centerCurrentlyOpenModal() {
    if (currently_open_modal && currently_open_modal.isOpen()) {
        currently_open_modal.updatePosition();
    }
}
